export const COMPANY = {
  name: "GridJob OÜ",
  legalForm: "Osaühing (OÜ)",
  address: "Tartu mnt 67/1-13b, 10115 Tallinn, Harju maakond, Estonia",
  registryCode: "[Registry code — to be added]",
  vat: "[VAT number — to be added, if registered]",
  email: "[Email — to be added]",
  phone: "[Phone — to be added]",
  board: "[Management board member — to be added]",
  founded: "2026",
  domain: "grid-job.com",
  updated: "2026-10-26",
};

const TOKENS = {
  name: COMPANY.name,
  address: COMPANY.address,
  registry: COMPANY.registryCode,
  vat: COMPANY.vat,
  email: COMPANY.email,
  phone: COMPANY.phone,
  board: COMPANY.board,
  domain: COMPANY.domain,
};

export const fill = (s) => String(s ?? "").replace(/\{\{(\w+)\}\}/g, (_, k) => TOKENS[k] ?? "");
